"use client";

import React, { useEffect } from "react";
import { Link } from "react-router-dom";

// Courses component
const CoursesPG = ({ program, isMobile = false, onCourseClick}) => {


  const apiUrl = process.env.REACT_APP_IMAGE_URL

  // useEffect(()=>{
  //   console.log("pogrm ", program.records)
  //   console.log("pi vulture" , apiUrl)
  // },[])
  if (!program) {
    return null;
  }


  return (
    <div className="">
      {/* Program Title */}
      <h2 className={`flex text-[20px] font-semibold text-primary-color pb-[6px]`}>
        <span className="mx-1">{program.programName} {!isMobile ? "-" : ""} </span>
        {!isMobile ? <span>{program.count} courses</span> : <></>} 
      </h2>

      {/* Courses */}
      <ul className={`grid ${isMobile ? "grid-cols-1 mt-[12px]" : "grid-cols-2  mt-[15px]"} pr-3 h-[48vh] overflow-y-auto  text-slate-950 gap-5`}>
        {program &&
          program.records.map((course, index) => (
            <li
              className="relative border border-slate-200 rounded-md cursor-pointer pr-4 w-full h-[156px]  p-[14px] text-[14px] hover:bg-gradient-to-r from-[#04236b0d] to-[#ff99000d] transition-colors"
              key={index}
            >
              <Link to={`/program/${course.programId}`} onClick={onCourseClick}>
                {course.tag !== "" && !isMobile && <span
                  className={`absolute top-0 right-0 text-white rounded-tr-md rounded-bl-md py-[2px] px-[6px] text-[12px] font-normal ${course.tag === "New"
                    ? "bg-secondary-color"
                    : "bg-primary-color"
                    }`}
                >
                  {/* {course.fields.tag} */}
                  {/* Course tag */}
                  {course.tag} {/* Course tag */}
                </span>}

                <div className="flex flex-row space-x-[20px] items-center">
                  <img
                    src={`${apiUrl}/university/logo/${course.universityId}.png`}
                    width={50}
                    height={50}
                    alt="img"
                    className="w-[50px] h-[50px] object-contain"
                  />

                  <h3 className="font-semibold">
                    {course.programName}
                  </h3>
                </div>

                <p className="font-normal mt-[12px] line-clamp-2">
                  {course.description}
                </p>

                {!isMobile ? <span className="font-normal text-secondary-color">
                  {course.duration}
                </span> : <></>}
              </Link>
            </li>
          ))}
      </ul>
    </div>
  );
};

export default CoursesPG;
